import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from '../../index';
import {NotificationService} from '../../../../services/notification.service';
import {
  actionDocumentStage,
  getAllDocumentStages,
  loadDocumentStages,
  upsertDocumentStage
} from './document-stage.actions';
import {map, switchMap} from 'rxjs/operators';
import {Apollo} from 'apollo-angular';
import {GET_DOCUMENT_STAGE, SAVE_DOCUMENT_STAGE} from './document-stage.graphql';
import {ActionTypeEnum} from '../../../../shared/enums/data.enums';
import {SettingsService} from '../../../../services/settings.service';

@Injectable()
export class DocumentStageEffects {

  get = createEffect(() => this.actions$.pipe(
    ofType(getAllDocumentStages),
    switchMap(() => {
      return this.apollo.query({
        query: GET_DOCUMENT_STAGE
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000){
            this.store.dispatch(loadDocumentStages({documentStages: result?.data}));
          }
        })
      );
    })
  ), { dispatch: false });


  save = createEffect(() => this.actions$.pipe(
    ofType(actionDocumentStage),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: SAVE_DOCUMENT_STAGE,
        variables: { inputDto: action.documentStageDto }
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000){
            this.notificationService.successMessageAndCloseModals(result?.response?.message);
            if (action.documentStageDto.actionType === ActionTypeEnum.delete){
              this.settingsService.reloadCurrentRoute(null);
            }

            this.store.dispatch(upsertDocumentStage({documentStage: result?.data}));
          }else {
            this.notificationService.errorMessage(result?.response?.message);
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private apollo: Apollo,
    private notificationService: NotificationService,
    private settingsService: SettingsService
  ) {
  }
}
